import React from 'react';
import { useTranslation } from 'react-i18next';
import './cadastroFinalizado.css';
import { useNavigate } from 'react-router-dom';

const CadastroFinalizado = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <>
      <div id="finalizacao" className="card bg-superficie elev5">
        <img
          alt={t('cadastro.accessibility.carol_image')}
          id="img-carol-boasvindas"
          src="/images/carol-perfil.png"
        />
        <br />
        <h1>{t('cadastro.titles.completed')}</h1>
        <p>{t('cadastro.messages.success.account_created')}</p>

        <button className="btn-pre" onClick={() => navigate('/login')}>
          {t('cadastro.forms.buttons.finalize_and_login')}
        </button>
      </div>
    </>
  );
};
export default CadastroFinalizado;
